var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container login-wrap"},[_c('router-view',{attrs:{"name":"sidebar"}}),_c('Login'),_c('button',{staticClass:"support",attrs:{"type":"button"},on:{"click":_vm.openQuestions}},[_vm._v(" "+_vm._s(_vm.$t('no_booking_yet_contact_our_support'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }